import React, { useEffect } from 'react';
import PresenterQuestionListContainer from './presenter-question-list-container/presenter-question-list-container';
import './presenter.scss';
import { observer } from 'mobx-react';
import { useStore } from '../../store/store-provider';
import { QandaTabs } from '../../constans/question-enums';
import classnames from 'classnames';
import { PresenterTabsOnMobile } from '../../constans/presenter-enums';
import Tab from '../shared/tabs-container/tab/tab';
import PresenterSlidePermissionsHOC from './presenter-slide-permissions-hoc/presenter-slide-permissions-hoc';
import PresenterSlideWrapper from './presenter-slide-wrapper';
import QandASubscriptionHOC from '../q-a/qanda-subscription-hoc';
import { DESKTOP_BREAKPOINT } from '../../constans/responsive-break-points';
import { QandaPermissionHOC } from '../q-a/qanda-permissions-hoc';
import { Redirect, useParams } from 'react-router';
import { IRouteParams } from '../../pages/container/container';
import { getDefaultRouteRedirectPath } from '../../utils/helpers/features-routes-helpers';
import { Permissions } from '../../store/permissions-store/permissions-store';

const Presenter = () => {
  const { podiumInfoStore, slideManagementStore, authStore, permissionsStore } = useStore();
  const { getPodiumUserSessionInfo } = authStore;
  const { isPodiumSlidesEnabled, isPodiumPresenterQuestionsEnabled } = permissionsStore;
  const { id } = useParams<IRouteParams>();
  const {
    setPresenterInfo,
    getPresentationSlides,
    isSlidesManagementAvailable,
    activeMobileNavigationTab,
    setActiveMobileNavigationTab
  } = slideManagementStore;
  const { updateSelectedTab, isResolutionBreakPointActive } = podiumInfoStore;
  const isMobile = isResolutionBreakPointActive(DESKTOP_BREAKPOINT);

  const isClickerMobileTab = activeMobileNavigationTab === PresenterTabsOnMobile.CLICKER && isMobile;

  useEffect(() => {
    getPresentationSlides();
    setPresenterInfo(getPodiumUserSessionInfo());
    updateSelectedTab(QandaTabs.EMPTY);
    return () => updateSelectedTab(QandaTabs.UNANSWERED);
  }, []);

  const isSelected = (tabName: PresenterTabsOnMobile | PresenterTabsOnMobile[]): boolean => {
    if (!isMobile) return !isMobile;
    else if (Array.isArray(tabName)) return tabName.includes(activeMobileNavigationTab);
    else return activeMobileNavigationTab === tabName;
  };

  if ((isPodiumSlidesEnabled() != null && !isPodiumSlidesEnabled()) &&
        (isPodiumPresenterQuestionsEnabled() != null && !isPodiumPresenterQuestionsEnabled())) {
    const path = getDefaultRouteRedirectPath(permissionsStore);
    return <Redirect to={`/presentation/${id}${path}`}/>;
  }

  /** Presenter page always should have subscription for Questions. And that's why it wrapped by HOC */
  return (
    <QandASubscriptionHOC>
      <div
        className={classnames('presenter-page-wrapper', {
          'slide-management-available': isSlidesManagementAvailable
        })}
      >
        <PresenterSlidePermissionsHOC>
          <PresenterSlideWrapper
            mobileSelectTab={activeMobileNavigationTab}
            isMobile={isMobile}
            isClickerMobileTab={isClickerMobileTab}
            isSelected={isSelected}
            setMobileSelectTab={setActiveMobileNavigationTab}
          />
        </PresenterSlidePermissionsHOC>

        <QandaPermissionHOC shouldRedirect={false} variant={Permissions.PresenterQuestions}>
          <Tab isSelected={isSelected(PresenterTabsOnMobile.QUESTIONS)}>
            <section className="presenter-questions">
              <PresenterQuestionListContainer/>
            </section>
          </Tab>
        </QandaPermissionHOC>
      </div>
    </QandASubscriptionHOC>
  );
};

export default observer(Presenter);
